import React from 'react'
import PropTypes from 'prop-types'
import fullstory from '../../../utils/constants/fullstory'

const renderSelectInput = ({
  className,
  input,
  options,
  label,
  meta: { touched, error },
  ...rest
}) => {
  return (
    <div className="form-group">
      {label !== '' && <label>{label}</label>}
      <select
        className={`form-control ${className} ${fullstory.classNames.selectInput}`}
        onBlur={input.onBlur}
        onChange={input.onChange}
        value={input.value}
        disabled={!options.length}
        {...rest}
      >
        <option value={undefined} />
        {options.map(opt => (
          <option
            key={opt.value}
            value={opt.value}
            className={`${fullstory.classNames.selectInput}`}
          >
            {opt.displayName}
          </option>
        ))}
      </select>
      {touched && error && (
        <h6 className="text-danger small text-justify" style={{ marginTop: '5px' }}>
          {error}
        </h6>
      )}
    </div>
  )
}

renderSelectInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.any.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  meta: PropTypes.any,
}

renderSelectInput.defaultProps = {
  label: '',
}

export default renderSelectInput



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderSelectInput.js